import React from "react";
import { AppBar, Toolbar } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import MuiButton from "Components/MuiButton/MuiButton";
import { logout } from "Stores/actions";
import { ReactSVG } from "react-svg";
import PowerIcon from "Assets/svg/icon/power.svg";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";
import { read, store } from "Helpers/LocalStorage";
import * as Icons from "react-bootstrap-icons";
import { useEffect } from "react";
import { clearFakeStorage } from "Helpers/analyzeToken";
import { SET_MENU_DRAWER, TRANSFER } from "Stores/actionTypes";

export default function Header({ rtlLayout, name }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { transfer, menuStatus } = useSelector((state) => ({
    transfer: state.auth.transfer,
    menuStatus: state.auth.menuStatus,
  }));

  const onExit = () => {
    dispatch(logout());
  };

  const disabledTransport = () => {
    store("StypeSwAllow", false);
    dispatch({ type: TRANSFER, transfer: false });
  };

  useEffect(() => {
    if (transfer) {
      const interval = setInterval(() => {
        if (!read("StypeSwAllow")) {
          clearFakeStorage();
          clearInterval(interval);
          // window.location.href = window.location.href;
          window.location.reload();
        }
      }, 1000);
    }
  }, [transfer]);

  const setMenuDrawer = () => {
    dispatch({ type: SET_MENU_DRAWER, status: !menuStatus });
  };

  return (
    <AppBar className="appBar d-flex fixed-top">
      <Toolbar className={`rtl-${rtlLayout}`}>
        <div className={"w-100 d-flex justify-content-between"}>
          <div className="d-flex flex-row justify-content-center align-items-center g-2 mx-0 mx-sm-3">
            <div className="menu-icon" onClick={setMenuDrawer}>
              <Icons.List />
            </div>
            <span className="d-none d-sm-block">
              {`${t("userName")} : ${name}`}
            </span>
          </div>
          <div className="mx-3 d-flex flex-row">
            {transfer && (
              <div className="ml-1">
                <MuiButton
                  className="MuiButton-danger-link"
                  title={<Translator id="disabledTransport" />}
                  startIcon={<Icons.BuildingX />}
                  onClick={disabledTransport}
                />
              </div>
            )}
            <div className="">
              <MuiButton
                className="toolbar-menu out"
                title={<Translator id="exit" />}
                startIcon={<ReactSVG src={PowerIcon} />}
                onClick={onExit}
              />
            </div>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
}
